export default {
  Wait : 0,
  Approved : 1,
  Rejected : 2,
}
